import React from "react";

import {PEACH_SUPPORT_EMAIL} from "../utils/constants";
import {Typography, Box} from "@material-ui/core";
import GoogleAnalyticsUtil from "../utils/google.analytics.util";
import MenuBar from "../components/menu.bar";
import FloatingButton from "../components/floating.button";
import TextUtils from "../utils/text.utils";
import PhasesContainer from "../components/phases.container.component";

interface MainPagePropsInterface {
    activePhase: string;
    merchantName: string;
    descriptor: string;
    phases: Array<any>;
    highestCompletedOrder: number;
    googleAnalytics: GoogleAnalyticsUtil;
}

interface MainPageStateInterface {
    supportText: string;
}


class MainPage extends React.Component<MainPagePropsInterface, MainPageStateInterface> {
    private readonly _supportTextDefault: string = "Support";

    constructor(props: MainPagePropsInterface) {
        super(props);

        this.state = {
            supportText: this._supportTextDefault
        };

    }

    componentDidMount(): void {
        this.props.googleAnalytics.trackPage("Status Page");
    }

    handleSupportClick = () => {
        const supportText: string = this.state.supportText.indexOf("support@peachpayments.com") !== -1 ? this._supportTextDefault : "support@peachpayments.com";

        this.setState({
            supportText: supportText
        });

        if (supportText.indexOf("support@peachpayments.com") !== -1) {
            this.props.googleAnalytics.trackEvent("support");
            TextUtils.copyToClipboard(PEACH_SUPPORT_EMAIL);
        }

    };

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (<>
            <MenuBar title={"Activate your business"}
            />
            <Box className={"bottomPadding"} pl={2} pr={2}>
                <Typography className={"topPadding"} align={"center"} variant="h4" style={{fontSize: "20px"}}>
                    <b>{this.props.merchantName}</b>
                </Typography>
                <Typography align={"center"} variant="subtitle1" style={{marginTop: "12px", fontSize: "14px"}}>
                    {this.props.descriptor}
                </Typography>
                <PhasesContainer activePhaseOrder={this.props.highestCompletedOrder} phaseObject={this.props.phases}/>
            </Box>
            <FloatingButton mobileText={"Copied!"} clickCallback={this.handleSupportClick}
                            text={this.state.supportText}/>
        </>);

    }
}

export default MainPage;